module.exports = __webpack_public_path__ + "img/label-mc-bb2.5c6b85a2.png";